import React from "react";
import { Container } from "@mui/material"; 
import ResetPassword from "../ResetPassword/ResetPassword";

 export const ResetPasswordPage = () => {
  return (
    <Container maxWidth="100%"  sx={{ paddingTop: "7%", }}> 
    <ResetPassword/>
     </Container>
  );
};

